import { CalendarX2 } from "lucide-react";
import { useLang } from "../../lib/i18n";

export const ClosuresNotice = ({ closures, compact = false, testId = "closures-notice" }) => {
  const { t, lang } = useLang();
  const list = Array.isArray(closures) ? closures : [];
  if (!list.length) return null;
  const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", { weekday: "short", day: "numeric", month: "short" });
  return (
    <div data-testid={testId} className={`rounded-2xl border border-slate-400/30 bg-slate-400/10 ${compact ? "p-4" : "p-5 sm:p-6"}`}>
      <div className="flex items-start gap-3">
        <CalendarX2 className="h-5 w-5 mt-0.5 shrink-0 text-slate-300" />
        <div className="min-w-0">
          <p className="font-semibold text-sm sm:text-base">{t("closed.title")}</p>
          <p className="text-xs sm:text-sm text-[var(--sage)]">{t("closed.sub")}</p>
          <ul className="mt-3 flex flex-wrap gap-2">
            {list.map((h) => (
              <li key={h.date} data-testid={`closure-${h.date}`} className="rounded-full bg-black/25 border hairline px-3 py-1.5 text-xs sm:text-sm">
                {fmt(h.date)}{h.reason ? <span className="text-[var(--sage)]"> · {h.reason}</span> : null}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
